(function () {
    // utm字段
    var utmObj = {
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_content: '',
        utm_term: ''
    };
    // 获取utm字段，任意一个字段有值，把所有的值都替换，都无值的时候，取现有cookie
    var utm_source = common.getUrlPara('utm_source') || '';
    var utm_medium = common.getUrlPara('utm_medium') || '';
    var utm_campaign = common.getUrlPara('utm_campaign') || '';
    var utm_content = common.getUrlPara('utm_content') || '';
    var utm_term = common.getUrlPara('utm_term') || '';

    if (utm_source || utm_medium || utm_campaign || utm_content || utm_term) {
        utmObj = {
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_campaign: utm_campaign,
            utm_content: utm_content,
            utm_term: utm_term
        };
        common.setCookie('utmObj', JSON.stringify(utmObj));
    } else {
        if (common.getCookie('utmObj')) {
            utmObj = JSON.parse(common.getCookie('utmObj'));
        }
    }

    utmObj.modulesources = common.getUrlPara('linksourcemodule') || window.cateData.userRecodeOption.module || window.cateData.pageModuleName || '';

    window.common_utmObj = utmObj;
})();
